<template>
    <FormSection title="Contacts" :full-height="false" :application-id="application">
        <template #content>
            <section class="d-flex flex-column px-3 py-2">
                <div class="d-flex justify-content-end" v-if="!isReOrderRequested && !showContactForm">
                    <button class="btn btn-primary mb-2" @click="requestReOrder()" v-if="totalContacts > 1">
                        Reorder Contacts
                    </button>
                    <button
                        class="btn btn-primary ms-2 mb-2"
                        @click="openAddContact()"
                        v-if="totalContacts < contactLimit"
                    >
                        New Contact
                    </button>
                </div>
                <div class="d-flex justify-content-end" v-if="isReOrderRequested">
                    <button class="btn btn-primary mb-2" @click="confirmReOrder()" v-if="totalContacts > 1">
                        <i class="fa fa-spinner fa-spin" v-if="isSavingReOrder"></i>
                        {{ !isSavingReOrder ? "Save Reorder" : "Saving Reorder" }}
                    </button>
                    <button class="btn btn-outline-primary ms-2 mb-2" @click="cancelReOrder()">Cancel</button>
                </div>
                <div
                    :class="`card material-card my-2 animated ${
                        showContactForm ? 'faster fadeInDown' : 'slow fadeOutUp'
                    }`"
                    v-if="showContactForm"
                >
                    <div class="p-3">
                        <EmergencyContactsForm
                            ref="contactForm"
                            :contact="contact"
                            :cahps-survey-recipient-index="Number(cahpsSurveyRecipientIndex)"
                            :is-palliative="isApplicationPalliative"
                            :patient-primary-address="patientPrimaryAddress"
                            :relationships-enum="relationshipEnum"
                            :contact-roles-enum="contactRolesEnum"
                            :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                            :is-editable="true"
                            :total-contacts="totalContacts"
                            :is-loading="isLoading"
                            :referral="referral"
                        />
                    </div>
                    <footer class="d-flex justify-content-center" v-if="!isLoading">
                        <button type="button" class="btn btn-primary me-2 mb-2" @click="addContact()">
                            Add Contact
                        </button>
                        <button type="button" class="btn btn-outline-primary mb-2" @click="closeAddContact()">
                            Cancel
                        </button>
                    </footer>
                </div>
                <EmergencyContactsList
                    ref="contactList"
                    :is-re-order-requested="isReOrderRequested"
                    :patient-primary-address="patientPrimaryAddress"
                    v-model:totalContacts="totalContacts"
                    :patient-id="patientId"
                    :is-palliative="isApplicationPalliative"
                    :cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                    :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                    :relationships-enum="relationshipEnum"
                    :contact-roles-enum="contactRolesEnum"
                    :referral="referral"
                    :is-editing="isEditing"
                    v-on:updateIsEditing="updateIsEditing"
                />
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EmergencyContactsSection.ts"></script>
